// Setup function - P5.js initialization

import type p5 from 'p5';
import { lanes, loadHighScoreFromStorage } from '../store';
import { CONFIG } from '../config/game-config';
import { initThreeJS } from '../features/background/three-renderer';
import { initStageBackground } from '../features/background/background';
import { resetGame } from '../engine/reset';
import { initViewportScaler } from '../engine/viewport-scaler';

/**
 * setup() - P5.jsの初期化関数
 * キャンバス作成、Three.js初期化、背景星の初期化、ゲームリセット
 * @param p - P5.jsインスタンス
 */
export function setup(p: p5): void {
    // キャンバスを作成してコンテナに追加（HUDパネル込みの幅）
    const canvas = p.createCanvas(CONFIG.layout.canvasWidth, CONFIG.height);
    canvas.parent('game-container');

    // ビューポートスケーリング初期化（モバイル対応）
    initViewportScaler(p);

    // Three.jsの初期化
    initThreeJS();

    // localStorageからハイスコアを読み込み
    loadHighScoreFromStorage();

    // レーンのX座標を計算（ゲームエリア内、オフセット適用）
    // 2レーンの場合: 左レーン=220, 右レーン=420 (gameAreaX=120, 幅400の場合)
    const laneWidth = CONFIG.width / CONFIG.laneCount;
    for (let i = 0; i < CONFIG.laneCount; i++) {
        lanes.push(CONFIG.layout.gameAreaX + laneWidth * i + laneWidth / 2);
    }

    // ステージ背景用の星を初期化
    initStageBackground();

    // ゲームをリセット
    resetGame();
}
